import axios from "axios";
import Vue from "vue";
export const state = {
  fees_payments: [],
  fees_receipt: {},
  bursary_categories: [],
  termly_report: [],
  periodic_report: [],
  bursaries: [],
  fees_exemptions: [],
  ledger: [],
  fees_additions: [],
  previous_debts: [],
  items: [],
  setting: [],
  structure: [],
  payment_breakdown: [],
  receipts: [],
  save_status: false,
  other_fees: [],
  pay_fees_items: [],
};
export const getters = {
  FeesBursaries: (state) => state.bursaries,
  FeesReceipt: (state) => state.fees_receipt,
  BursaryCategories: (state) => state.bursary_categories.data,
  FeesLedger: (state) => state.ledger,
  FeesItems: (state) => state.items,
  FeesSettings: (state) => state.setting.data,
  FeesExemptions: (state) => state.fees_exemptions.data,
  FeesAdditions: (state) => state.fees_additions.data,
  FeesPayments: (state) => state.fees_payments,
  PaymentBreakdown: (state) => state.payment_breakdown,
  FeesStructure: (state) => state.structure,
  FeesReceipts: (state) => state.receipts.data,
  PreviousDebts: (state) => state.previous_debts,
  TermlyReport: (state) => state.termly_report,
  PeriodicReport: (state) => state.periodic_report,
  SaveStatus: (state) => state.save_status,
  OtherFees: (state) => state.other_fees.data,
  getPayFeesItems: (state) => state.pay_fees_items,
};

export const mutations = {
  SET_PAY_FEES_ITEMS(state, newValue) {
    state.pay_fees_items = newValue;
  },
  SET_BURSARIES(state, newValue) {
    state.bursaries = newValue;
  },
  SET_BURSARY_CATEGORIES(state, newValue) {
    state.bursary_categories = newValue;
  },
  SET_ITEMS(state, newValue) {
    state.items = newValue;
  },
  SET_SETTING(state, newValue) {
    state.setting = newValue;
  },
  SET_FEES(state, newValue) {
    state.fees_payments = newValue;
  },
  SET_EXEMPTIONS(state, newValue) {
    state.fees_exemptions = newValue;
  },
  SET_ADDITIONS(state, newValue) {
    state.fees_additions = newValue;
  },
  SET_LEDGER(state, newValue) {
    state.ledger = newValue;
  },
  SET_RECEIPTS(state, newValue) {
    state.receipts = newValue;
  },
  SET_RECEIPT(state, newValue) {
    state.fees_receipt = newValue;
  },
  SET_STRUCTURE(state, newValue) {
    state.structure = newValue;
  },
  SET_PREVIOUS_DEBTS(state, newValue) {
    state.previous_debts = newValue;
  },
  SET_TERMLY_REPORT(state, newValue) {
    state.termly_report = newValue;
  },
  SET_PERIODIC_REPORT(state, newValue) {
    state.periodic_report = newValue;
  },
  SET_PAYMENT_BREAKDOWN(state, newValue) {
    state.payment_breakdown = newValue;
  },
  SET_OTHERFEES(state, newValue) {
    state.other_fees = newValue;
  },
  SET_SAVE_STATUS(state, newValue) {
    state.save_status = newValue;
  },
  pushNotification(state, payload) {
    Vue.notify({
      type: payload.type,
      group: "foo",
      title: payload.title,
      text: payload.message,
      position: "bottom right",
      duration: 10000,
      speed: 500,
    });
  },
};

export const actions = {
  addItem({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .post("fees_items", payload)
      .then(() => {
        dispatch("fetchItems");
        commit("SET_SAVE_STATUS", false);
        const message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message: "Successfully, Fees Item Added Successfully",
        };
        commit("pushNotification", message);
      })
      .catch((error) => {
        commit("SET_SAVE_STATUS", false);
        let message = {
          type: "error",
          title: "<b>Error Occured</b>",
          message: "Unexpected Error Occured",
        };
        if (error.response.status == 422) {
          const errorData = error.response.data;
          message.title = "<b>" + errorData.msg + "</b>";
          message.message = errorData.error;
        }
        commit("pushNotification", message);
      });
  },

  //filter items by year
  filterItemsYear({ commit }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .post("fees_items/filter", payload)
      .then((pos) => {
        commit("SET_ITEMS", pos.data);
        commit("SET_SAVE_STATUS", false);
      })
      .catch((error) => {
        commit("SET_SAVE_STATUS", false);
        let message = {
          type: "error",
          title: "<b>Error Occured</b>",
          message: "Unexpected Error Occured",
        };
        if (error.response.status == 422) {
          const errorData = error.response.data;
          message.title = "<b>" + errorData.msg + "</b>";
          message.message = errorData.error;
        }
        commit("pushNotification", message);
      });
  },

  // Edit Item
  editItem({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .put(`fees_items/${payload.id}`, payload)
      .then(() => {
        dispatch("fetchItems");
        commit("SET_SAVE_STATUS", false);
        const message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message: "Successfully, Fees Item Edited Successfully",
        };
        commit("pushNotification", message);
      })
      .catch((error) => {
        commit("SET_SAVE_STATUS", false);
        let message = {
          type: "error",
          title: "<b>Error Occured</b>",
          message: "Unexpected Error Occured",
        };
        if (error.response.status == 422) {
          const errorData = error.response.data;
          message.title = "<b>" + errorData.msg + "</b>";
          message.message = errorData.error;
        }
        commit("pushNotification", message);
      });
  },
  // Delete Item
  deleteItem({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .delete(`fees_items/${payload.id}`)
      .then(() => {
        dispatch("fetchItems");
        commit("SET_SAVE_STATUS", false);
        const message = {
          type: "primary",
          title: "<b>Success Notifications</b>",
          message: "Successfully, Fees Item Deleted Successfully",
        };
        commit("pushNotification", message);
      })
      .catch((error) => {
        commit("SET_SAVE_STATUS", false);
        let message = {
          type: "error",
          title: "<b>Error Occured</b>",
          message: "Unexpected Error Occured",
        };
        if (error.response.status == 422) {
          const errorData = error.response.data;
          message.title = "<b>" + errorData.msg + "</b>";
          message.message = errorData.error;
        }
        commit("pushNotification", message);
      });
  },

  // Fees setting
  addFeesSetting({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .post("fees_settings", payload)
      .then(() => {
        dispatch("fetchFeesSettings");
        commit("SET_SAVE_STATUS", false);
        const message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message: "Successfully, Fees Settings Added Successfully",
        };
        commit("pushNotification", message);
      })
      .catch((error) => {
        commit("SET_SAVE_STATUS", false);
        let message = {
          type: "error",
          title: "<b>Error Occured</b>",
          message: "Unexpected Error Occured",
        };
        if (error.response.status == 422) {
          const errorData = error.response.data;
          message.title = "<b>" + errorData.msg + "</b>";
          message.message = errorData.error;
        }
        commit("pushNotification", message);
      });
  },

  editFeesSetting({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .put(`fees_settings/${payload.id}`, payload)
      .then(() => {
        dispatch("fetchFeesSettings");
        commit("SET_SAVE_STATUS", false);
        const message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message: "Successfully, Fees Settings Edited Successfully",
        };
        commit("pushNotification", message);
      })
      .catch((error) => {
        commit("SET_SAVE_STATUS", false);
        let message = {
          type: "error",
          title: "<b>Error Occured</b>",
          message: "Unexpected Error Occured",
        };
        if (error.response.status == 422) {
          const errorData = error.response.data;
          message.title = "<b>" + errorData.msg + "</b>";
          message.message = errorData.error;
        }
        commit("pushNotification", message);
      });
  },

  deleteFeesSetting({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .delete(`fees_settings/${payload.id}`)
      .then(() => {
        dispatch("fetchFeesSettings");
        commit("SET_SAVE_STATUS", false);
        const message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message: "Successfully, Fees Settings Deleted Successfully",
        };
        commit("pushNotification", message);
      })
      .catch((error) => {
        commit("SET_SAVE_STATUS", false);
        let message = {
          type: "error",
          title: "<b>Error Occured</b>",
          message: "Unexpected Error Occured",
        };
        if (error.response.status == 422) {
          const errorData = error.response.data;
          message.title = "<b>" + errorData.msg + "</b>";
          message.message = errorData.error;
        }
        commit("pushNotification", message);
      });
  },

  // Fees Exemption
  addFeesExemption({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .post("exemptions", payload)
      .then(() => {
        dispatch("fetchFeesExemptions");
        commit("SET_SAVE_STATUS", false);
        const message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message: "Successfully, Fees Exemption Added Successfully",
        };
        commit("pushNotification", message);
      })
      .catch((error) => {
        commit("SET_SAVE_STATUS", false);
        let message = {
          type: "error",
          title: "<b>Error Occured</b>",
          message: "Unexpected Error Occured",
        };
        if (error.response.status == 422) {
          const errorData = error.response.data;
          message.title = "<b>" + errorData.msg + "</b>";
          message.message = errorData.error;
        }
        commit("pushNotification", message);
      });
  },

  editFeesExemption({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .put(`exemptions/${payload.id}`, payload)
      .then(() => {
        dispatch("fetchFeesExemptions");
        commit("SET_SAVE_STATUS", false);
        const message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message: "Successfully, Fees Exemption Edited Successfully",
        };
        commit("pushNotification", message);
      })
      .catch((error) => {
        commit("SET_SAVE_STATUS", false);
        let message = {
          type: "error",
          title: "<b>Error Occured</b>",
          message: "Unexpected Error Occured",
        };
        if (error.response.status == 422) {
          const errorData = error.response.data;
          message.title = "<b>" + errorData.msg + "</b>";
          message.message = errorData.error;
        }
        commit("pushNotification", message);
      });
  },

  deleteFeesExemption({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .delete(`exemptions/${payload.id}`)
      .then(() => {
        dispatch("fetchFeesExemptions");
        commit("SET_SAVE_STATUS", false);
        const message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message: "Successfully, Fees Exemption Deleted Successfully",
        };
        commit("pushNotification", message);
      })
      .catch((error) => {
        commit("SET_SAVE_STATUS", false);
        let message = {
          type: "error",
          title: "<b>Error Occured</b>",
          message: "Unexpected Error Occured",
        };
        if (error.response.status == 422) {
          const errorData = error.response.data;
          message.title = "<b>" + errorData.msg + "</b>";
          message.message = errorData.error;
        }
        commit("pushNotification", message);
      });
  },

  // Fees Addition
  addFeesAddition({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .post("fees_additions", payload)
      .then(() => {
        dispatch("fetchFeesAdditions");
        commit("SET_SAVE_STATUS", false);
        const message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message: "Successfully, Fees Additions Added Successfully",
        };
        commit("pushNotification", message);
      })
      .catch((error) => {
        commit("SET_SAVE_STATUS", false);
        let message = {
          type: "error",
          title: "<b>Error Occured</b>",
          message: "Unexpected Error Occured",
        };
        if (error.response.status == 422) {
          const errorData = error.response.data;
          message.title = "<b>" + errorData.msg + "</b>";
          message.message = errorData.error;
        }
        commit("pushNotification", message);
      });
  },

  editFeesAddition({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .put(`fees_additions/${payload.id}`, payload)
      .then(() => {
        dispatch("fetchFeesAdditions");
        commit("SET_SAVE_STATUS", false);
        const message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message: "Successfully, Fees Additions Edited Successfully",
        };
        commit("pushNotification", message);
      })
      .catch((error) => {
        commit("SET_SAVE_STATUS", false);
        let message = {
          type: "error",
          title: "<b>Error Occured</b>",
          message: "Unexpected Error Occured",
        };
        if (error.response.status == 422) {
          const errorData = error.response.data;
          message.title = "<b>" + errorData.msg + "</b>";
          message.message = errorData.error;
        }
        commit("pushNotification", message);
      });
  },

  deleteFeesAddition({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .delete(`fees_additions/${payload.id}`)
      .then(() => {
        dispatch("fetchFeesAdditions");
        commit("SET_SAVE_STATUS", false);
        const message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message: "Successfully, Fees Additions Deleted Successfully",
        };
        commit("pushNotification", message);
      })
      .catch((error) => {
        commit("SET_SAVE_STATUS", false);
        let message = {
          type: "error",
          title: "<b>Error Occured</b>",
          message: "Unexpected Error Occured",
        };
        if (error.response.status == 422) {
          const errorData = error.response.data;
          message.title = "<b>" + errorData.msg + "</b>";
          message.message = errorData.error;
        }
        commit("pushNotification", message);
      });
  },
  // Breakdown payment
  // Fees Addition
  addPaymentBreakdown({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .post("payment_breakdown", payload)
      .then((res) => {
        var message = {};
        if (res.status == 202 || res.status == 201) {
          message = {
            type: "error",
            title: "<b>Error Notifications</b>",
            message: res.data.message,
          };
        } else {
          dispatch("fetchPaymentBreakdown", payload.id);
          message = {
            type: "success",
            title: "<b>Success Notifications</b>",
            message: "Successfully, Breakdown Added Successfully",
          };
        }
        commit("SET_SAVE_STATUS", false);
        commit("pushNotification", message);
      })
      .catch((error) => {
        commit("SET_SAVE_STATUS", false);
        let message = {
          type: "error",
          title: "<b>Error Occured</b>",
          message: "Unexpected Error Occured",
        };
        if (error.response.status == 422) {
          const errorData = error.response.data;
          message.title = "<b>" + errorData.msg + "</b>";
          message.message = errorData.error;
        }
        commit("pushNotification", message);
      });
  },

  saveBreakdown({ commit }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .post("save_payment_breakdown", payload)
      .then(() => {
        const message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message: "Successfully, Breakdown Added Successfully",
        };
        commit("SET_SAVE_STATUS", false);
        commit("pushNotification", message);
      })
      .catch((error) => {
        commit("SET_SAVE_STATUS", false);
        let message = {
          type: "error",
          title: "<b>Error Occured</b>",
          message: "Unexpected Error Occured",
        };
        if (error.response.status == 422) {
          const errorData = error.response.data;
          message.title = "<b>" + errorData.msg + "</b>";
          message.message = errorData.error;
        }
        commit("pushNotification", message);
      });
  },

  deletePaymentBreakdown({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .delete(`payment_breakdown/${payload.item}`)
      .then(() => {
        dispatch("fetchPaymentBreakdown", payload.id);
        commit("SET_SAVE_STATUS", false);
        const message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message: "Successfully, Breakdown Deleted Successfully",
        };
        commit("pushNotification", message);
      })
      .catch((error) => {
        commit("SET_SAVE_STATUS", false);
        let message = {
          type: "error",
          title: "<b>Error Occured</b>",
          message: "Unexpected Error Occured",
        };
        if (error.response.status == 422) {
          const errorData = error.response.data;
          message.title = "<b>" + errorData.msg + "</b>";
          message.message = errorData.error;
        }
        commit("pushNotification", message);
      });
  },

  // Bursary Categories
  addBursaryCategory({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .post("bursary_categories", payload)
      .then(() => {
        dispatch("fetchBursaryCategories");
        commit("SET_SAVE_STATUS", false);
        const message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message: "Successfully, Bursary Added Successfully",
        };
        commit("pushNotification", message);
      })
      .catch((error) => {
        commit("SET_SAVE_STATUS", false);
        let message = {
          type: "error",
          title: "<b>Error Occured</b>",
          message: "Unexpected Error Occured",
        };
        if (error.response.status == 422) {
          const errorData = error.response.data;
          message.title = "<b>" + errorData.msg + "</b>";
          message.message = errorData.error;
        }
        commit("pushNotification", message);
      });
  },
  // Edit BursaryCategory
  editBursaryCategory({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .put(`bursary_categories/${payload.id}`, payload)
      .then(() => {
        dispatch("fetchBursaryCategories");
        commit("SET_SAVE_STATUS", false);
        const message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message: "Successfully, Bursary Edited Successfully",
        };
        commit("pushNotification", message);
      })
      .catch((error) => {
        commit("SET_SAVE_STATUS", false);
        let message = {
          type: "error",
          title: "<b>Error Occured</b>",
          message: "Unexpected Error Occured",
        };
        if (error.response.status == 422) {
          const errorData = error.response.data;
          message.title = "<b>" + errorData.msg + "</b>";
          message.message = errorData.error;
        }
        commit("pushNotification", message);
      });
  },
  // Delete BursaryCategory
  deleteBursaryCategory({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .delete(`bursary_categories/${payload.id}`)
      .then(() => {
        dispatch("fetchBursaryCategories");
        commit("SET_SAVE_STATUS", false);
        const message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message: "Successfully, Bursary Deleted Successfully",
        };
        commit("pushNotification", message);
      })
      .catch((error) => {
        commit("SET_SAVE_STATUS", false);
        let message = {
          type: "error",
          title: "<b>Error Occured</b>",
          message: "Unexpected Error Occured",
        };
        if (error.response.status == 422) {
          const errorData = error.response.data;
          message.title = "<b>" + errorData.msg + "</b>";
          message.message = errorData.error;
        }
        commit("pushNotification", message);
      });
  },

  // Bursaries
  addFeesBursary({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .post("bursaries", payload)
      .then(() => {
        dispatch("fetchBursaries");
        commit("SET_SAVE_STATUS", false);
        const message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message: "Successfully, Bursary Added Successfully",
        };
        commit("pushNotification", message);
      })
      .catch((error) => {
        commit("SET_SAVE_STATUS", false);
        let message = {
          type: "error",
          title: "<b>Error Occured</b>",
          message: "Unexpected Error Occured",
        };
        if (error.response.status == 422) {
          const errorData = error.response.data;
          message.title = "<b>" + errorData.msg + "</b>";
          message.message = errorData.error;
        }
        commit("pushNotification", message);
      });
  },
  // Edit Bursaries
  editFeesBursary({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .put(`bursaries/${payload.id}`, payload)
      .then(() => {
        dispatch("fetchBursaries");
        commit("SET_SAVE_STATUS", false);
        const message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message: "Successfully, Bursary Edited Successfully",
        };
        commit("pushNotification", message);
      })
      .catch((error) => {
        commit("SET_SAVE_STATUS", false);
        let message = {
          type: "error",
          title: "<b>Error Occured</b>",
          message: "Unexpected Error Occured",
        };
        if (error.response.status == 422) {
          const errorData = error.response.data;
          message.title = "<b>" + errorData.msg + "</b>";
          message.message = errorData.error;
        }
        commit("pushNotification", message);
      });
  },
  // Delete Bursaries
  deleteFeesBursary({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .delete(`bursaries/${payload.id}`)
      .then(() => {
        dispatch("fetchBursaries");
        commit("SET_SAVE_STATUS", false);
        const message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message: "Successfully, Bursary Deleted Successfully",
        };
        commit("pushNotification", message);
      })
      .catch((error) => {
        commit("SET_SAVE_STATUS", false);
        let message = {
          type: "error",
          title: "<b>Error Occured</b>",
          message: "Unexpected Error Occured",
        };
        if (error.response.status == 422) {
          const errorData = error.response.data;
          message.title = "<b>" + errorData.msg + "</b>";
          message.message = errorData.error;
        }
        commit("pushNotification", message);
      });
  },
  //post other fees
  addotherFees({ commit }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .post("otherfees", payload)
      .then(() => {
        commit("SET_SAVE_STATUS", false);
        commit("fetchOtherFees", payload.student_id);
        const message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message: "Successfully, Action was Successfully",
        };
        commit("pushNotification", message);
      })
      .catch((error) => {
        commit("SET_SAVE_STATUS", false);
        let message = {
          type: "error",
          title: "<b>Error Occured</b>",
          message: "Unexpected Error Occured",
        };
        if (error.response.status == 422) {
          const errorData = error.response.data;
          message.title = "<b>" + errorData.msg + "</b>";
          message.message = errorData.error;
        }
        commit("pushNotification", message);
      });
  },

  //get other fees
  fetchOtherFees({ commit }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .get(`fetchOtherFees/${payload.id}`)
      .then((res) => {
        commit("SET_SAVE_STATUS", false);
        commit("SET_OTHERFEES", res.data);
      })
      .catch((error) => {
        commit("SET_SAVE_STATUS", false);
        let message = {
          type: "error",
          title: "<b>Error Occured</b>",
          message: "Unexpected Error Occured",
        };
        if (error.response.status == 422) {
          const errorData = error.response.data;
          message.title = "<b>" + errorData.msg + "</b>";
          message.message = errorData.error;
        }
        commit("pushNotification", message);
      });
  },
  // Delete other Fees
  deleteOtherFees({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .post(`otherFessDelete/delete`, payload)
      .then(() => {
        dispatch("fetchOtherFees");
        const message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message: "Fees deleted Successfully",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      })
      .catch((error) => {
        commit("SET_SAVE_STATUS", false);
        let message = {
          type: "error",
          title: "<b>Error Occured</b>",
          message: "Unexpected Error Occured",
        };
        if (error.response.status == 422) {
          const errorData = error.response.data;
          message.title = "<b>" + errorData.msg + "</b>";
          message.message = errorData.error;
        }
        commit("pushNotification", message);
      });
  },
  // Edit Amount Paid
  editAmtPaid({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .put(`fees/${payload.id}`, payload)
      .then(() => {
        dispatch(`fetchLedger`, payload.sid);
        commit("SET_SAVE_STATUS", false);
        const message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message: "Successfully, Amount Edited Successfully",
        };
        commit("pushNotification", message);
      })
      .catch((error) => {
        commit("SET_SAVE_STATUS", false);
        let message = {
          type: "error",
          title: "<b>Error Occured</b>",
          message: "Unexpected Error Occured",
        };
        if (error.response.status == 422) {
          const errorData = error.response.data;
          message.title = "<b>" + errorData.msg + "</b>";
          message.message = errorData.error;
        }
        commit("pushNotification", message);
      });
  },
  // Delete Fees Payment Record
  deletePayment({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .delete(`fees/${payload.id}`)
      .then(() => {
        dispatch(`fetchLedger`, payload.sid);
        commit("SET_SAVE_STATUS", false);
        const message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message: "Successfully, Payment Deleted Successfully",
        };
        commit("pushNotification", message);
      })
      .catch((error) => {
        commit("SET_SAVE_STATUS", false);
        let message = {
          type: "error",
          title: "<b>Error Occured</b>",
          message: "Unexpected Error Occured",
        };
        if (error.response.status == 422) {
          const errorData = error.response.data;
          message.title = "<b>" + errorData.msg + "</b>";
          message.message = errorData.error;
        }
        commit("pushNotification", message);
      });
  },

  printfeesDef({ commit }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios({
      url: "/generate_feesDef",
      method: "post",
      data: payload,
      responseType: "blob",
    })
      .then((response) => {
        commit("SET_SAVE_STATUS", false);
        // Create a new Blob object using the response data
        const file = new Blob([response.data], {
          type: "application/pdf",
        });

        // Create a URL for the file
        const fileURL = URL.createObjectURL(file);

        // Open the PDF in a new tab
        const newWindow = window.open(fileURL);

        // Wait for the file to load before triggering the print dialog
        if (newWindow) {
          newWindow.onload = function() {
            newWindow.focus();
            newWindow.print();
          };
        }
      })
      .catch((error) => {
        commit("SET_SAVE_STATUS", false);
        let message = {
          type: "error",
          title: "<b>Error Occured</b>",
          message: "Unexpected Error Occured",
        };
        if (error.response.status == 422) {
          const errorData = error.response.data;
          message.title = "<b>" + errorData.msg + "</b>";
          message.message = errorData.error;
        }
        commit("pushNotification", message);
      });
  },
  fetchLedgedoc({ commit }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios({
      url: "/generate_ledger",
      method: "post",
      data: payload,
      responseType: "blob",
    })
      .then((response) => {
        commit("SET_SAVE_STATUS", false);
        // Create a new Blob object using the response data
        const file = new Blob([response.data], {
          type: "application/pdf",
        });

        // Create a URL for the file
        const fileURL = URL.createObjectURL(file);

        // Open the PDF in a new tab
        const newWindow = window.open(fileURL);

        // Wait for the file to load before triggering the print dialog
        if (newWindow) {
          newWindow.onload = function() {
            newWindow.focus();
            newWindow.print();
          };
        }
      })
      .catch((error) => {
        commit("SET_SAVE_STATUS", false);
        let message = {
          type: "error",
          title: "<b>Error Occured</b>",
          message: "Unexpected Error Occured",
        };
        if (error.response.status == 422) {
          const errorData = error.response.data;
          message.title = "<b>" + errorData.msg + "</b>";
          message.message = errorData.error;
        }
        commit("pushNotification", message);
      });
  },
  requestReceipt({ commit }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios({
      url: "/generate_receipt",
      method: "post",
      data: payload,
      responseType: "blob",
    })
      .then((response) => {
        commit("SET_SAVE_STATUS", false);
        // Create a new Blob object using the response data
        const file = new Blob([response.data], {
          type: "application/pdf",
        });

        // Create a URL for the file
        const fileURL = URL.createObjectURL(file);

        // Open the PDF in a new tab
        const newWindow = window.open(fileURL);

        // Wait for the file to load before triggering the print dialog
        if (newWindow) {
          newWindow.onload = function() {
            newWindow.focus();
            newWindow.print();
          };
        }
      })
      .catch((error) => {
        commit("SET_SAVE_STATUS", false);
        let message = {
          type: "error",
          title: "<b>Error Occured</b>",
          message: "Unexpected Error Occured",
        };
        if (error.response.status == 422) {
          const errorData = error.response.data;
          message.title = "<b>" + errorData.msg + "</b>";
          message.message = errorData.error;
        }
        commit("pushNotification", message);
      });
  },
requestInvoice({ commit }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios({
      url: "/generate_invoice",
      method: "post",
      data: payload,
      responseType: "blob",
    })
      .then((response) => {
        commit("SET_SAVE_STATUS", false);
        // Create a new Blob object using the response data
        const file = new Blob([response.data], {
          type: "application/pdf",
        });

        // Create a URL for the file
        const fileURL = URL.createObjectURL(file);

        // Open the PDF in a new tab
        const newWindow = window.open(fileURL);

        // Wait for the file to load before triggering the print dialog
        if (newWindow) {
          newWindow.onload = function() {
            newWindow.focus();
            newWindow.print();
          };
        }
      })
      .catch((error) => {
        commit("SET_SAVE_STATUS", false);
        let message = {
          type: "error",
          title: "<b>Error Occured</b>",
          message: "Unexpected Error Occured",
        };
        if (error.response.status == 422) {
          const errorData = error.response.data;
          message.title = "<b>" + errorData.msg + "</b>";
          message.message = errorData.error;
        }
        commit("pushNotification", message);
      });
  },

  // Pay Fees
  pay({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios({
      method: "post",
      url: "/fees",
      data: payload,
      responseType: "blob",
    })
      .then((response) => {
        dispatch("fetchFees");
        commit("SET_SAVE_STATUS", false);
        const message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message: "Successfully, Amount Paid Successfully",
        };
        commit("pushNotification", message);

        // Create a new Blob object using the response data
        const file = new Blob([response.data], {
          type: "application/pdf",
        });

        // Create a URL for the file
        const fileURL = URL.createObjectURL(file);

        // Open the PDF in a new tab
        const newWindow = window.open(fileURL);

        // Wait for the file to load before triggering the print dialog
        if (newWindow) {
          newWindow.onload = function() {
            newWindow.focus();
            newWindow.print();
          };
        }
      })
      .catch(async (error) => {
        commit("SET_SAVE_STATUS", false);
        let message = {
          type: "error",
          title: "<b>Error Occured</b>",
          message: "Unexpected Error Occured",
        };
        if (error.response && error.response.status === 422) {
        try {
          // Convert blob to text
          const errorText = await error.response.data.text();
          // Parse JSON from text
          const errorData = JSON.parse(errorText);

          message.title = "<b>" + errorData.msg + "</b>";
          message.message = errorData.error;
        } catch (e) {
          message.message = "Failed to parse error message.";
        }
      }
        commit("pushNotification", message);
      });
  },

  // pay Fees Items
  payFeesItems({ commit }, payload) {
    axios
      .post("pay_fees_item", payload)
      .then((res) => {
        commit("SET_PAY_FEES_ITEMS", res.data);
      })
      .catch((error) => {
        commit("SET_SAVE_STATUS", false);
        let message = {
          type: "error",
          title: "<b>Error Occured</b>",
          message: "Unexpected Error Occured",
        };
        if (error.response.status == 422) {
          const errorData = error.response.data;
          message.title = "<b>" + errorData.msg + "</b>";
          message.message = errorData.error;
        }
        commit("pushNotification", message);
      });
  },

  //Set previous debts
  savePDebts({ commit }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .post("save_previous_debts", payload)
      .then(() => {
        commit("SET_SAVE_STATUS", false);
        // const message = {
        //   type: "success",
        //   title: "<b>Success Notifications</b>",
        //   message: "Successfully, Action was Successfully",
        // };
        // commit("pushNotification", message);
      })
      .catch(() => {
        commit("SET_SAVE_STATUS", false);
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occurred",
        };
        commit("pushNotification", message);
      });
  },

  fetchItems({ commit }) {
    axios.get(`fees_items`).then((pos) => {
      commit("SET_ITEMS", pos.data);
    });
  },
  fetchFeesSettings({ commit }) {
    axios.get(`fees_settings`).then((sta) => {
      commit("SET_SETTING", sta.data);
    });
  },
  fetchFees({ commit }, payload) {
    axios.post(`fees_balances`, payload).then((sta) => {
      commit("SET_FEES", sta.data);
    });
  },
  fetchFeesExemptions({ commit }) {
    axios.get(`exemptions`).then((sta) => {
      commit("SET_EXEMPTIONS", sta.data);
    });
  },
  fetchFeesAdditions({ commit }) {
    axios.get(`fees_additions`).then((sta) => {
      commit("SET_ADDITIONS", sta.data);
    });
  },
  fetchBursaryCategories({ commit }) {
    axios.get(`bursary_categories`).then((sta) => {
      commit("SET_BURSARY_CATEGORIES", sta.data);
    });
  },
  fetchBursaries({ commit }) {
    axios.get(`bursaries`).then((sta) => {
      commit("SET_BURSARIES", sta.data);
    });
  },
  fetchLedger({ commit }, id) {
    axios.get(`ledger/${id}`).then((ledger) => {
      commit("SET_LEDGER", ledger.data);
    });
  },
  fetchFeesStructure({ commit }, payload) {
    axios.post(`fees_structure`, payload).then((data) => {
      commit("SET_STRUCTURE", data.data);
    });
  },
  fetchFeesReceipts({ commit }, payload) {
    axios.post(`fees_receipts`, payload).then((ledger) => {
      commit("SET_RECEIPTS", ledger.data);
    });
  },
  fetchPaymentBreakdown({ commit }, id) {
    axios.get(`payment_breakdown/${id}`).then((payment) => {
      commit("SET_PAYMENT_BREAKDOWN", payment.data);
    });
  },
  fetchTermlyReport({ commit }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .post(`fees_termly_report`, payload)
      .then((ledger) => {
        commit("SET_TERMLY_REPORT", ledger.data);
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        commit("SET_SAVE_STATUS", false);
      });
  },
  fetchPeriodicReport({ commit }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .post(`fees_periodic_report`, payload)
      .then((ledger) => {
        commit("SET_PERIODIC_REPORT", ledger.data);
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        commit("SET_SAVE_STATUS", false);
      });
  },
  fetchReceipt({ commit }, id) {
    axios.get(`fees/${id}`).then((ledger) => {
      commit("SET_RECEIPT", ledger.data);
    });
  },
  fetchPreviousDebts({ commit }, payload) {
    axios.post(`get_previous_debts`, payload).then((ledger) => {
      commit("SET_PREVIOUS_DEBTS", ledger.data);
    });
  },
};
